import { handleActions } from 'redux-actions';
import { defaultGdprWidgetState } from './defaults';
import { GdprWidgetData, GdprWidgetStep } from './types';
import { initPersonalDataPage } from '../../actions';
import {
  setGdprWidgetStep,
  submitPersonalDataRemoveRequest,
  submitPersonalDataRemoveRequestFailure,
  submitPersonalDataRemoveRequestSuccess,
  submitPersonalDataRequest,
  submitPersonalDataRequestFailure,
  submitPersonalDataRequestSuccess,
  submitPersonalDataResendDataRemovalConfirmationLink,
  submitPersonalDataResendDataRemovalConfirmationLinkFailure,
  submitPersonalDataResendDataRemovalConfirmationLinkSuccess,
} from './actions';
import { NetworkRequestState } from '../baseTypes';

export default handleActions<GdprWidgetData, any>(
  {
    [initPersonalDataPage.toString()]: (
      state,
      action: ReturnType<typeof initPersonalDataPage>
    ) => {
      const {
        isDeactivated,
        isGdprLinkSent,
        isRemoveRequestInProgress,
        isPersonaldataRequestInitiated,
        isRemoveRequestInitiated,
        emailQueryParams,
      } = action.payload.data;
      return {
        ...defaultGdprWidgetState,
        step:
          emailQueryParams?.ts && emailQueryParams?.token
            ? GdprWidgetStep.RemoveDataInProgress
            : GdprWidgetStep.Initial,
        isPersonaldataRequestInitiated: isPersonaldataRequestInitiated,
        isRemoveRequestInitiated: isRemoveRequestInitiated,
        isRemoveRequestInProgress: isRemoveRequestInProgress,
        isGdprLinkSent: isGdprLinkSent,
        isDeactivated: isDeactivated,
        emailQueryParams: emailQueryParams,
        networkRequests: {
          ...defaultGdprWidgetState.networkRequests,
          initiateRemoveDataRequest: {
            status: isRemoveRequestInitiated
              ? NetworkRequestState.SUCCESS
              : NetworkRequestState.IDLE,
            errors: {},
          },
        },
      };
    },
    [submitPersonalDataRequest.toString()]: (
      state,
      action: ReturnType<typeof submitPersonalDataRequest>
    ) => ({
      ...state,
      networkRequests: {
        ...state.networkRequests,
        personalDataRequest: {
          status: NetworkRequestState.SENT_AND_WAITING_FOR_RESPONSE,
          errors: {},
        },
      },
    }),
    [submitPersonalDataRequestSuccess.toString()]: (
      state,
      action: ReturnType<typeof submitPersonalDataRequestSuccess>
    ) => ({
      ...state,
      isPersonaldataRequestInitiated: true,
      networkRequests: {
        ...state.networkRequests,
        personalDataRequest: {
          status: NetworkRequestState.SUCCESS,
          errors: {},
        },
      },
    }),
    [submitPersonalDataRequestFailure.toString()]: (
      state,
      action: ReturnType<typeof submitPersonalDataRequestFailure>
    ) => ({
      ...state,
      networkRequests: {
        ...state.networkRequests,
        personalDataRequest: {
          status: NetworkRequestState.FAILURE,
          errors: action.payload.errors,
          errorMessage: action.payload.errorMessage,
        },
      },
    }),
    [submitPersonalDataRemoveRequest.toString()]: (
      state,
      action: ReturnType<typeof submitPersonalDataRemoveRequest>
    ) => ({
      ...state,
      isRemoveRequestInitiated: true,
      networkRequests: {
        ...state.networkRequests,
        initiateRemoveDataRequest: {
          status: NetworkRequestState.SENT_AND_WAITING_FOR_RESPONSE,
          errors: {},
        },
      },
    }),
    [submitPersonalDataRemoveRequestSuccess.toString()]: (
      state,
      action: ReturnType<typeof submitPersonalDataRemoveRequestSuccess>
    ) => ({
      ...state,
      isRemoveRequestInitiated: true,
      isRemoveRequestInProgress: false,
      networkRequests: {
        ...state.networkRequests,
        initiateRemoveDataRequest: {
          status: NetworkRequestState.SUCCESS,
          errors: {},
        },
      },
    }),
    [submitPersonalDataRemoveRequestFailure.toString()]: (
      state,
      action: ReturnType<typeof submitPersonalDataRemoveRequestFailure>
    ) => ({
      ...state,
      isRemoveRequestInitiated: false,
      isRemoveRequestInProgress: false,
      networkRequests: {
        ...state.networkRequests,
        initiateRemoveDataRequest: {
          status: NetworkRequestState.FAILURE,
          errors: action.payload.errors,
          errorMessage: action.payload.errorMessage,
        },
      },
    }),
    [submitPersonalDataResendDataRemovalConfirmationLink.toString()]: (
      state,
      action: ReturnType<
        typeof submitPersonalDataResendDataRemovalConfirmationLink
      >
    ) => ({
      ...state,
      isGdprLinkSent: true,
      networkRequests: {
        ...state.networkRequests,
        resendDownloadLinkRequest: {
          status: NetworkRequestState.SENT_AND_WAITING_FOR_RESPONSE,
          errors: {},
        },
      },
    }),
    [submitPersonalDataResendDataRemovalConfirmationLinkSuccess.toString()]: (
      state,
      action: ReturnType<
        typeof submitPersonalDataResendDataRemovalConfirmationLinkSuccess
      >
    ) => ({
      ...state,
      isGdprLinkSent: true,
      networkRequests: {
        ...state.networkRequests,
        resendDownloadLinkRequest: {
          status: NetworkRequestState.SUCCESS,
          errors: {},
        },
      },
    }),
    [submitPersonalDataResendDataRemovalConfirmationLinkFailure.toString()]: (
      state,
      action: ReturnType<
        typeof submitPersonalDataResendDataRemovalConfirmationLinkFailure
      >
    ) => ({
      ...state,
      isGdprLinkSent: false,
      networkRequests: {
        ...state.networkRequests,
        resendDownloadLinkRequest: {
          status: NetworkRequestState.FAILURE,
          errors: action.payload.errors,
          errorMessage: action.payload.errorMessage,
        },
      },
    }),
    [setGdprWidgetStep.toString()]: (
      state,
      action: ReturnType<typeof setGdprWidgetStep>
    ) => ({
      ...state,
      step: action.payload.step,
    }),
  },
  defaultGdprWidgetState
);
